// action types
import { createRequestTypes } from "../../utils";

export const FETCH_USER_CART = createRequestTypes("FETCH_USER_CART");
export const SET_DELIVERY_ADDRESS = createRequestTypes("SET_DELIVERY_ADDRESS");
export const SET_SHIPPING_TYPE = createRequestTypes("SET_SHIPPING_TYPE");
export const FETCH_USER_CART_ITEMS = createRequestTypes("FETCH_USER_CART_ITEMS");
export const UPDATE_CART_ITEM = createRequestTypes("UPDATE_CART_ITEM");
export const REMOVE_CART_ITEM = createRequestTypes("REMOVE_CART_ITEM");
export const ADD_CART_ITEM = createRequestTypes("ADD_CART_ITEM");
export const APPLY_DISCOUNT = createRequestTypes("APPLY_DISCOUNT");


// FETCH CART 
export const fetchUserCartRequest = () =>
  ({ type: FETCH_USER_CART.REQUEST });

export const fetchUserCartSuccess = (payload) =>
  ({ type: FETCH_USER_CART.SUCCESS, payload });

export const fetchUserCartFailure = (error) =>
  ({ type: FETCH_USER_CART.FAILURE, payload: { error } });



// Setting a delivery address
export const setDeliveryAddressRequest = (id) =>
  ({ type: SET_DELIVERY_ADDRESS.REQUEST, payload: { id } });
export const setDeliveryAddressSuccess = (payload) =>
  ({ type: SET_DELIVERY_ADDRESS.SUCCESS, payload });
export const setDeliveryAddressFailure = (error) =>
  ({ type: SET_DELIVERY_ADDRESS.FAILURE, payload: { error } });



// Setting shypping type 
export const setShippingTypeRequest = (shipping_type) =>
  ({ type: SET_SHIPPING_TYPE.REQUEST, payload: { shipping_type } });

export const setShippingTypeSuccess = (payload) =>
  ({ type: SET_SHIPPING_TYPE.SUCCESS, payload });

export const setShippingTypeFailure = (error) =>
  ({ type: SET_SHIPPING_TYPE.FAILURE, payload: { error } });


// FETCH CART ITEMS
export const fetchUserCartItemsRequest = () =>
  ({ type: FETCH_USER_CART_ITEMS.REQUEST });

export const fetchUserCartItemsSuccess = (cartItems) =>
  ({ type: FETCH_USER_CART_ITEMS.SUCCESS, payload: { cartItems } });

export const fetchUserCartItemsFailure = (error) =>
  ({ type: FETCH_USER_CART_ITEMS.FAILURE, payload: { error } });


// UPDATE
export const updateCartItemRequest = (unique_code, quantity) =>
  ({ type: UPDATE_CART_ITEM.REQUEST, payload: { unique_code, quantity } });

export const updateCartItemSuccess = (cartItems) =>
  ({ type: UPDATE_CART_ITEM.SUCCESS, payload: { cartItems } });

export const updateCartItemFailure = (error) =>
  ({ type: UPDATE_CART_ITEM.FAILURE, payload: { error } });

// REMOVE
export const removeCartItemRequest = (itemId) =>
  ({ type: REMOVE_CART_ITEM.REQUEST, payload: { itemId } });

export const removeCartItemSuccess = (cartItems) =>
  ({ type: REMOVE_CART_ITEM.SUCCESS, payload: { cartItems } });

export const removeCartItemFailure = (error) =>
  ({ type: REMOVE_CART_ITEM.FAILURE, payload: { error } });


// ADD - supports both unique_code (presentations) and product_code (direct products)
export const addCartItemRequest = (unique_code, quantity, product_code = null) =>
  ({ type: ADD_CART_ITEM.REQUEST, payload: { unique_code, quantity, product_code } });

export const addCartItemSuccess = (cartItems) =>
  ({ type: ADD_CART_ITEM.SUCCESS, payload: { cartItems } });

export const addCartItemFailure = (error) =>
  ({ type: ADD_CART_ITEM.FAILURE, payload: { error } });

// ADD by product code (for products without presentations)
export const addProductToCartRequest = (product_code, quantity) =>
  ({ type: ADD_CART_ITEM.REQUEST, payload: { unique_code: null, quantity, product_code } });


// APPLY DISCOUNT
export const applyDiscountRequest = (discount_code) =>
  ({ type: APPLY_DISCOUNT.REQUEST, payload: { discount_code } });

export const applyDiscountSuccess = (payload) =>
  ({ type: APPLY_DISCOUNT.SUCCESS, payload });

export const applyDiscountFailure = (error) =>
  ({ type: APPLY_DISCOUNT.FAILURE, payload: { error } });